module.exports = __webpack_public_path__ + "img/poweredbyblue.fc086786.svg";